import { createContext } from '@chakra-ui/react-utils';

import type { PartProps } from '../Part';

export const [PartProvider, usePartContext] = createContext<PartProps>({
  name: 'PartContext',
  errorMessage:
    'usePartContext: `context` is undefined. Seems you forgot to wrap all menu components within `<Part />`',
});
